import React, { useState, useEffect } from 'react';
import './HerokuLoader.css';

const HerokuLoader = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState('Waking up the server...');
  const [showHerokuInfo, setShowHerokuInfo] = useState(false);

  useEffect(() => {
    const startTime = Date.now();
    let messageTimer;

    // Show different messages based on loading time
    const updateMessage = () => {
      const elapsed = Date.now() - startTime;
      
      if (elapsed < 3000) {
        setLoadingMessage('Loading FarmBalance Resilience App...');
      } else if (elapsed < 8000) {
        setLoadingMessage('Waking up the server...');
        setShowHerokuInfo(true);
      } else if (elapsed < 15000) {
        setLoadingMessage('Almost ready...');
      } else {
        setLoadingMessage('Taking longer than usual...');
      }
    };

    // Update message every 2 seconds
    messageTimer = setInterval(updateMessage, 2000);
    updateMessage(); // Initial call

    // Simulate app loading completion
    const checkAppReady = () => {
      // In a real scenario, you might ping an endpoint or check if React has fully loaded
      // For now, we'll simulate a minimum loading time and then hide the loader
      const minLoadTime = 2000; // Minimum 2 seconds to show branding
      const elapsed = Date.now() - startTime;
      
      if (elapsed >= minLoadTime) {
        setIsLoading(false);
      } else {
        setTimeout(() => setIsLoading(false), minLoadTime - elapsed);
      }
    };

    // Check if app is ready after a short delay
    setTimeout(checkAppReady, 1000);

    return () => {
      if (messageTimer) clearInterval(messageTimer);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="heroku-loader">
        <div className="heroku-loader-content">
          <div className="heroku-loader-spinner">
            <div className="heroku-spinner"></div>
          </div>
          
          <h2>Loading</h2>
          <p className="heroku-loader-message">{loadingMessage}</p>
          
          {showHerokuInfo && (
            <div className="heroku-loader-info">
              <p>
                <small>
                  Our server is starting up. This may take a moment on the first visit.
                </small>
              </p>
            </div>
          )}
          
          <div className="heroku-loader-progress">
            <div className="heroku-progress-bar">
              <div className="heroku-progress-fill"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default HerokuLoader;